import type { ButtonHTMLAttributes, ReactNode } from "react";
import s from "./IconButton.module.css";
import { Tooltip } from "./Tooltip";

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  /** Optional keyboard hint shown in the tooltip, e.g. "Ctrl+P" */
  kbd?: string;
  active?: boolean;
  rail?: boolean;
  tooltipSide?: "top" | "right" | "bottom" | "left";
  children: ReactNode;
}

export function IconButton({ label, kbd, active, rail, tooltipSide, className, children, ...rest }: IconButtonProps) {
  const cls = [s.iconBtn, active ? s.active : "", rail ? s.rail : "", className ?? ""].filter(Boolean).join(" ");
  return (
    <Tooltip label={label} kbd={kbd} side={tooltipSide}>
      <button type="button" aria-label={label} className={cls} {...rest}>
        {children}
      </button>
    </Tooltip>
  );
}
